import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getLabourOperation = createAsyncThunk('/GetLabourOperation', async () => {
    const response = await axios.get(`/GetLabourOperation`);
    return response.data;
});

export const setLabourOperation = createAsyncThunk('/SetLabourOperation', async (push) => {
    const response = await axios.post(`/SetLabourOperation`,push);
    return response.data;
});

export const getLanguagelist = createAsyncThunk(
    '/getLanguageList',
    async () => {
        const response = await axios.get('/GetLanguageList');
        return response.data;
    }
);

const labourOperationSlice = createSlice({
    name: 'warrantyTimeException',
    initialState: {
        loading: false,
        error: '',
        LabourOperation: [],
        //WarrantyException:[],
        SelectedAppTranslationId: 0,
        response: '',
    },
    reducers: {
        changeSelectedAppTranslationId(state, action) {
            state.SelectedAppTranslationId = action.payload;
        },
    },

    extraReducers: {

        [getLabourOperation.pending]: (state) => {
            state.loading = true;
        },
        [getLabourOperation.rejected]: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        },
        [getLabourOperation.fulfilled]: (state, action) => {
            state.LabourOperation = action.payload;
            state.loading = false;
        },
        [setLabourOperation.pending]: (state) => {
            state.loading = true;
        },
        [setLabourOperation.rejected]: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        },
        [setLabourOperation.fulfilled]: (state, action) => {
            state.LabourOperation = action.payload;
            state.loading = false;
        },

    }
});

export const labourOperationActions = labourOperationSlice.actions

export default labourOperationSlice;
